import { useEffect } from "react";
import Products from '../table/Tableproducts';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import Modal from "../modal/Modaladdproduct"


const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Products/>
    
     
     </>
  );
};

export default Dashboard;
